import 'core-js/es/number';
import 'core-js/es/string';
import 'core-js/es/array';
import svg4everybody from 'svg4everybody';
import objectFitImages from 'object-fit-images';
import sayHello from './lib/sayHello';
import Select from './components/_select';
import Accordion from './components/_accordion';
import Form from './components/_form';
import sliders from './components/_sliders';
import video from './components/_video';
import header from './components/_header';
import fields from './components/_fields';

sayHello();


$(() => {
  header();
  Select.initAll();
  Accordion.initAll();
  Form.initAll();
  sliders();
  fields();
  video();
  objectFitImages();
  svg4everybody();
});
